export const deleteTagDisclaimer =
  'If you want to move this tag to another commit, add it to the new commit and it will automatically switch over. This action will remove it altogether.';

export enum PromptPageTabs {
  PROMPTS = 0,
  COMMITS = 1,
}
